// extracted by mini-css-extract-plugin
export var standaloneTable = "_dg-0";
export var standaloneTableWithBodyFill = "_dg-1";
export var withExtraHeader = "_dg-2";